import { Ride } from "../searchResult";

export const getBusStop = (ride: Ride, id: string | undefined) => {
  return ride && ride.stops.find((stopEl) => stopEl.stop.id === id);
};
